import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import { createBootstrap } from "bootstrap-vue-next";
import { QuillEditor } from "@vueup/vue-quill";
import Vue3Prism from "vue3-prism/lib/Vue3Prism.common.js";
import VueApexCharts from "vue3-apexcharts";

// FontAwesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import "flatpickr/dist/flatpickr.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "vue3-prism/lib/Vue3Prism.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/custom.scss";
import "bootstrap";
import acl from "./acl"; // import the instance of the defined ACL

// Adicionar todos os ícones à biblioteca
library.add(fas, far, fab);

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(Vue3Prism);
app.use(createBootstrap());
app.component("apexchart", VueApexCharts);
app.component("QuillEditor", QuillEditor);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(acl) 
app.mount("#app");
